import React from 'react';
import SocialLinks from './SocialLinks';

const Footer = () => (
    <footer className="bg-dark">
        <div className="container mx-auto px-5 py-4 text-center">
            <div className="flex justify-between">
                <div className="">
                    <a href="/" className="hover:underline">
                        Rakibul islam Raju
                    </a>
                    <span> &copy; 2021</span>
                </div>
                <SocialLinks />
            </div>
        </div>
    </footer>
);

export default Footer;
